import { useQuery, type QueryConfig } from 'react-query';

import { getDiagnosticsResults, type DiagnosticsResultsResponse } from '@yandex-int/k-common/client/api';

import { getUniqueQueryKey } from 'utils/getUniqueQueryKey';

const TeacherQueryKeys = {
    useDiagnosticsResults: getUniqueQueryKey('useDiagnosticsResults'),
};

/** Получить результаты диагностики по классу */
export function useDiagnosticsResults(
    teamId: number | null | undefined,
    slug: string | null | undefined,
    queryConfig?: QueryConfig<DiagnosticsResultsResponse>
) {
    return useQuery(
        [TeacherQueryKeys.useDiagnosticsResults, teamId, slug],
        () => (teamId && slug ? getDiagnosticsResults({ team_id: teamId, slug }) : Promise.resolve(null)),
        { ...queryConfig }
    );
}
